import { useEffect } from 'react';

const APP_NAME = 'NOXOR 粉絲平台';

/**
 * Sets `document.title` to `<title> · <APP_NAME>` on mount and
 * restores the previous title on unmount. Call once per page-level
 * component. Pass `null` to leave the title at the app default.
 */
export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    if (!title) {
      document.title = APP_NAME;
      return;
    }
    const prev = document.title;
    document.title = `${title} · ${APP_NAME}`;
    return () => { document.title = prev; };
  }, [title]);
}
